<div class="prefix-groups">
  <legend>Prefix Groups</legend>
  <arm-layout [summaryTitle]="'Prefix groups summary'" class="prefix-groups-layout">
    <div header>
      <div class="search-container">

        <arm-search (onSearch)="onSearch($event)"
                    [searchComponent]="prefixGroupsSearchComponent"
                    [searchData]="searchData"
                    [searchTerms]="searchTerms">
        </arm-search>
      </div>

      <div class="action-buttons">
        <arm-action-bar (addClick)="addItem()" [disableAdd]="isUnauthorized"
                        (deleteClick)="removeItem()"
                        [disableDelete]="isUnauthorized || !selection || selection.length === 0"
                        (refreshClick)="refresh()"
                        (editClick)="editItem()"
                        [disableEdit]="!selection || selection.length === 0"></arm-action-bar>
      </div>
    </div>
    <div summary>
      <prefix-groups-summary [selection]="selection">
      </prefix-groups-summary>
    </div>

    <div main>
      <arm-table [displayedColumns]="displayedColumns" (pageChanged)="pageChanged($event)"
                 (onSelection)="onSelection($event)" [data]="data.elements" [length]="data.totalElements"
                 [isMultipleSelection]="true"
                 [isClientSide]="false"></arm-table>
    </div>
  </arm-layout>
</div>
